import { Button } from 'components/atoms';
import { Form } from 'components/organisms';
import { clientAccountInitialValues } from 'components/organisms/forms/client-account/ClientAccountForm';
import { FormikHelpers } from 'formik';
import { useMutateOptions } from 'hooks';
import middleware from 'middleware';
import { useTranslation } from 'react-i18next';
import { PiUserPlus } from 'react-icons/pi';
import { useLocation, useNavigate } from 'react-router-dom';
import { useCreateClientAccount } from 'services/client-account';
import { IClientAccountForm } from 'services/client-account/types';
import { BUTTON_VARIANT } from 'types/components/button/button.interface';
import { getLastPathname } from 'utils/navbar/getParentPathname';

const CreateClientAccount = () => {
  const navigate = useNavigate();
  const i18nextPrefix = 'user';
  const { t } = useTranslation();

  const { mutateAsync, isPending } = useCreateClientAccount();

  const { pathname } = useLocation();

  const mutateOptions = useMutateOptions<IClientAccountForm>();

  const onSubmit = async (
    values: IClientAccountForm,
    helpers: FormikHelpers<IClientAccountForm>
  ) => {
    const body = middleware.clientAccount.formToMutation(values);

    await mutateAsync(body, {
      ...mutateOptions(helpers),
      onSuccess: ({ id }) => {
        navigate(`/client-account/${id}/${getLastPathname(pathname)}`);
      },
    });
  };

  return (
    <Form.ClientAccount
      i18nextPrefix={i18nextPrefix}
      initialValues={clientAccountInitialValues}
      backPath='client-account'
      onSubmit={onSubmit}
      status={{ displayMode: false }}
      topbarContent={
        <Button type='submit' variant={BUTTON_VARIANT.submit}>
          <Button.Text text={t('button.create')} />
          <Button.Icon icon={<PiUserPlus />} />
        </Button>
      }
    />
  );
};

export default CreateClientAccount;
